module.exports = __webpack_public_path__ + "static/media/dif_logo.8802f3dc.svg";